module.exports = __webpack_public_path__ + "img/colum-height.d1345985.svg";